import { t } from "i18next";

const MIME_TYPES_BY_FORMAT: Record<string, string> = {
  svg: "image/svg+xml",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  pdf: "application/pdf",
};

function isFileFormatAllowed(file: any, allowedFormats: string[]): boolean {
  return allowedFormats.some((format) => {
    const mimeType = MIME_TYPES_BY_FORMAT[format?.toLowerCase()];
    return !!mimeType && file?.type?.toLowerCase() === mimeType;
  });
}

function imageCheck({
  file,
  setMessage,
  setAttachmentDetails,
  setAttachmentObject,
}: any) {
  if (!file?.type?.startsWith("image/")) {
    setAttachmentDetails(null);
    setAttachmentObject({});
    setMessage(t("Please upload a valid image file."));
    return;
  }

  const img = new Image();
  const objectUrl = URL.createObjectURL(file);

  img.onload = function () {
    const { width, height } = img;

    // if (width <= 800 && height <= 400) {
    if (file.size <= 1024 * 1024) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result) {
          setAttachmentDetails({
            name: file?.name,
            base64URL: reader.result.toString(),
          });
        }
      };
      reader.readAsDataURL(file);
      setMessage("");
      setAttachmentObject(file);
    } else {
      setAttachmentDetails(null);
      setAttachmentObject({});
      setMessage(t("File size exceeds the maximum limit of 1 MB."));
    }

    URL.revokeObjectURL(objectUrl);
  };

  img.src = objectUrl;
}

function onlyPDF({
  file,
  setAttachmentDetails,
  setMessage,
  setAttachmentObject,
}: any) {
  if (file?.type !== "application/pdf") {
    setAttachmentDetails(null);
    setAttachmentObject({});
    setMessage(t("Please upload a valid PDF file."));
    return;
  }

  const fileSizeInMB = file.size / (1024 * 1024);
  if (fileSizeInMB <= 50) {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) {
        setAttachmentDetails({
          name: file?.name,
          base64URL: reader.result.toString(),
        });
      }
    };
    reader.readAsDataURL(file);
    setMessage("");
    setAttachmentObject(file);
  } else {
    setAttachmentDetails(null);
    setAttachmentObject({});
    setMessage(t("The file size should be less than or equal to 50MB."));
  }
}

export { imageCheck, onlyPDF, isFileFormatAllowed };
